import getUserManager from "./userManager";
/**
 * Sign in an user
 */ export var signIn = function() {
    return getUserManager().then(function(userManager) {
        return userManager.signinSilent().then(function(user) {
            return user;
        }).catch(function() {
            return userManager.signinRedirect();
        });
    });
};
export default signIn;

//# sourceMappingURL=signIn.js.map